export function getSubscriptionUrl(accountId: string, subscriptionId: string, memberId?: string): string {
    const memberPath = memberId ? `/member/${memberId}` : ''

    return `/account/${accountId}/subscription/${subscriptionId}${memberPath}`
}
